import React from 'react';
import { Button } from 'antd';
import { formatNumber, setDefaultImage } from '../utils';
import { CloseOutlined, InfoCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';

import '../css/CartLine.less';

export default class CartLine extends React.Component {
    getPrice = (listPrice, price) => {
        return listPrice && Math.round(price) < Math.round(listPrice) ? (
            <div className={'cart-prices'}>
                <div className={'price old-price'}>{formatNumber(listPrice)}</div>
                <div className={'price discount-price'}>{formatNumber(price)}</div>
            </div>
        ) : (
            <div className={'cart-prices price'}>{formatNumber(price)}</div>
        );
    };

    render() {
        let imageSrc = this.props.image;
        if (imageSrc && !imageSrc.startsWith('http'))
            imageSrc = window.imageBase + this.props.image;
        return (
            <div
                className={
                    'cart-line' +
                    (this.props.upsell ? ' upsell' : '') +
                    (this.props.slimStyle ? ' slim' : '')
                }
                onClick={() =>
                    this.props.upsell
                        ? null
                        : window.location.assign('/SelectProd?prodId=' + this.props.productId)
                }
            >
                {this.props.slimStyle ? (
                    ''
                ) : (
                    <div className={'left'}>
                        <img
                            alt={this.props.name}
                            src={imageSrc}
                            onError={(e) => setDefaultImage(e)}
                        />
                    </div>
                )}
                <div className={'right'}>
                    {this.props.upsell ? (
                        <div className={'product-name'}>{this.props.name}</div>
                    ) : (
                        <a
                            className={'product-name black-link'}
                            href={'/SelectProd?prodId=' + this.props.productId}
                        >
                            {this.props.name}
                        </a>
                    )}
                    <div className={'cart-quantity-price'}>
                        <div className={'quantity'}>
                            {this.props.quantity && <span>Magn: {this.props.quantity}</span>}
                        </div>
                        {this.getPrice(this.props.listPrice, this.props.price)}
                    </div>
                    {this.props.upsellProducts ? (
                        <div className={'upsell-products'}>
                            {this.props.upsellProducts.map((oneItem) => {
                                return (
                                    <CartLine
                                        name={oneItem.name ? oneItem.name : oneItem.prodName}
                                        listPrice={oneItem.listPrice * oneItem.quantity}
                                        price={oneItem.price}
                                        slimStyle={true}
                                        upsell={true}
                                        removeProduct={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            this.props.removeProduct(
                                                e,
                                                oneItem.productId,
                                                oneItem.basketId
                                            );
                                        }}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        ''
                    )}
                    {this.props.openUpsellModal ? (
                        <div className={'upsell-available'}>
                            <Button
                                type="link"
                                className={'small'}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.props.openUpsellModal();
                                }}
                            >
                                <InfoCircleOutlined />{' '}
                                {process.env.REACT_APP_ADD_UPSELL_TEXT_CHECKOUT}
                            </Button>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                {this.props.removeProduct ? (
                    this.props.upsell ? (
                        <MinusCircleOutlined
                            className={'remove'}
                            onClick={(e) =>
                                this.props.removeProduct(
                                    e,
                                    this.props.productId,
                                    this.props.basketId
                                )
                            }
                        />
                    ) : (
                        <CloseOutlined
                            className={'remove'}
                            onClick={(e) =>
                                this.props.removeProduct(
                                    e,
                                    this.props.productId,
                                    this.props.basketId
                                )
                            }
                        />
                    )
                ) : (
                    ''
                )}
            </div>
        );
    }
}
